import {
  Component,
  HostBinding,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';

import { Observable } from 'rxjs';

import { AppSummarySectionConfig, SdfCardLabels } from '../app.models';
import {
  TransactionActions,
  TransactionStatus,
} from '../store/transaction/transaction.actions';
import {
  confirmRefundResponse,
  getRefundResponse,
  transactionStatusResponse,
} from '../store/transaction/transaction.selectors';
import { LaunchTransactionStatus, SetQueryParams } from '../store/query-params';
import { DialogService } from '../services/dialog.service';
import { getCountryConfig } from '../config/country-config';
import { getCurrentLabelsJson } from '../store/labels';
import {
  RefundModalData,
  SenderReceiverSection,
} from './transaction-status.model';
import {
  getAssociatedLocale,
  getSupportedLocale,
  isSdfCardFlow,
  languageList,
  PageTitles,
} from '../config/app-config';
import { UpdateWithdrawCountry } from '../store/service-options/service-options.actions';
import { MapService } from '../services/map.service';
import { UtilsService } from '../services/utils.service';
import { Error } from '../store/transaction';
import { TransactionStatusgModalComponent } from './transaction-status-modal/transaction-status-modal.component';
import { LocationResultServices } from '../models/location.model';
import { Clipboard } from '@angular/cdk/clipboard';
import { isEmpty, isNil, replace } from 'ramda';
import { LocationFinderService } from '../services/location-finder.service';

@Component({
    selector: 'app-transaction-status',
    templateUrl: './transaction-status.component.html',
    styleUrls: ['./transaction-status.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class TransactionStatusComponent implements OnInit {
  // @HostBinding('class') public klass = 'mat-elevation-z10'
  token!: string;
  labels!: any;
  helpText: string = '';
  helpTextLine2: string = '';
  transactionLabels!: any;
  transactionId!: string;
  sections: AppSummarySectionConfig[] = [];
  summarySections: AppSummarySectionConfig[] = [];
  transactionResponse: any;
  transactionSubstatus: any[] = [];
  trnStatus: string = '';
  transactionStatus: string = '';
  kind: string = '';
  confirmRefundRefNum: number | string = '';
  wallet: string = '';
  refNumber: number | string = '';
  locale: string = '';
  isRefundAllowed: boolean = false;
  exchangeRate: number = 1;
  currency: string = 'USD';
  selectedLocation!: any;
  locationDetails!: any;
  isCVSLocation: boolean = false;
  discounts = '0.00'; // todo: get it from  api objectout
  isMobile$: Observable<boolean>;
  isformFreeLocation: boolean = false;
  endpointVersion: string;
  labels$: Observable<any> | undefined;
  locationLabels: any;
  locationServices: any[];
  isSdfCardFlow: boolean;
  sdfCardLabels: SdfCardLabels;
  isEnglishFlow: boolean = true;
  totalAmount: any;
  totalAmountAddorSubFromWallet: any;
  totalAmountAddorSubFromWalletCurrency: string;
  totalAmountCurrency: string = 'USD';
  depositAmountString: any;
  withdrawAmountString: any;
  implicitUSCanada: string[] = ['USA', 'CAN'];
  isImplicitUSCanLocation: boolean = true;
  primaryIdDetails = 'DRV';
  showPayInstructions: boolean = false;
  languageList: any[];
  transactionStatusIconSrc = 'assets/images/green-confirmation-icon.svg';
  amountPaidOrPayAtStore = '';
  withdrawnOrDepositAmountString = '';

  public google: any;
  public dataLayer = ((<any>window).dataLayer = (<any>window).dataLayer || []);

  constructor(
    private route: ActivatedRoute,
    private store: Store<any>,
    private actions$: Actions,
    private dialogService: DialogService,
    private _snackBar: MatSnackBar,
    private mapService: MapService,
    private utilsService: UtilsService,
    private clipboard: Clipboard,
    public locationFinderService: LocationFinderService
  ) {
    this.isSdfCardFlow = isSdfCardFlow;
    this.languageList = languageList;
    this.mapService.loadMap(() => {
      this.google = google;
    });
  }

  ngOnInit(): void {
    // this.removeGlobalAsteriskCSSRule()
    this.isMobile$ = this.utilsService.isMobile;
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.transactionId = params['transaction_id'];
      this.wallet = params['wallet_provider'] || '';
      this.refNumber = params['refNumber'] || '';
      this.locale =
        params['lang'] && params['lang'].length === 2
          ? getAssociatedLocale(params['lang'])
          : getSupportedLocale(params['lang']);
      this.endpointVersion = this.isClientNameInJWT(this.token) ? 'v3' : 'v2';
    });

    const payload = {
      token: this.token,
      locale: this.locale,
      refNumber: this.refNumber,
      endpoint: this.endpointVersion,
    };
    if (this.token) {
      this.store.dispatch(
        LaunchTransactionStatus({
          queryParams: { queryParams: payload },
          endpoint: this.endpointVersion,
        })
      );
    }

    this.labels$ = this.store.select(getCurrentLabelsJson);

    this.store.select(getCurrentLabelsJson).subscribe((labels) => {
      this.labels = labels.labels;
      this.transactionLabels = this.labels?.stellar?.transactionStatus;
      if (!isEmpty(this.labels)) {
        this.isEnglishFlow = this.labels.stellar.cancelText === 'Cancel';
        this.sdfCardLabels = this.labels?.stellar.sdfcard;
      }

      this.locationLabels = this.labels?.stellar?.location;
      if (this.transactionLabels && this.transactionId) {
        this._paramsDataEvent();
        this.store.dispatch(
          TransactionStatus({
            transactionId: this.transactionId,
            refNumber: this.refNumber,
            endpoint: this.endpointVersion,
          })
        );
      }
    });

    this.store.select(confirmRefundResponse).subscribe((response) => {
      this.confirmRefundRefNum = response.referenceNumber;
      const error = response?.errors && response?.errors[0];
      if (error) {
        this._errorEvent(
          error,
          '',
          'confirmRefundError',
          'trnRefundConfirmDetails'
        );
      }
    });

    this.store.select(transactionStatusResponse).subscribe((response) => {
      this.transactionResponse = response;
      this.transactionSubstatus = this.transactionResponse?.substatus || [];
      if (this.transactionResponse) {
        this.getTotalAmount();
        this.isRefundAllowed = this.transactionResponse?.isRefundAllowedFlag;
        const flowType = this.transactionResponse?.kind
          ? this.transactionResponse?.kind?.toLowerCase()
          : '';
        this.kind = flowType.includes('with') ? 'withdraw' : 'deposit';
        if (this.kind === 'withdraw' && !this.refNumber) {
          this.refNumber = this?.transactionResponse?.referenceNumber || '';
        }
        this.getTotalAmount();
        this.exchangeRate =
          this.kind === 'deposit'
            ? this.transactionResponse?.sendAmountDetails?.fxRate
            : this.transactionResponse?.payoutAmountDetails?.fxRate;
        this.currency =
          this.transactionResponse?.payoutAmountDetails?.amount?.currencyCode;
        this.transactionStatus = this.transactionResponse?.transactionStatus;
        const customFields = this.transactionResponse?.customFields
          ? this.transactionResponse?.customFields[0]?.value
          : null;
        const selectedCountry = customFields || 'USA';
        if (this.kind === 'deposit') {
          this.selectedLocation = customFields && JSON.parse(customFields);
          if (this.selectedLocation) {
            this.locationDetails = this.selectedLocation?.locationDetails;
            this.isCVSLocation = this.locationDetails?.name?.includes('CVS') || false;
            this.locationServices = this.mapLocationServices(
              this.selectedLocation?.locationServices
            );
          }
          this.isformFreeLocation = this.selectedLocation?.locationServices
            ?.formFreeCompletion
            ? this.selectedLocation?.locationServices?.formFreeCompletion
            : false;
        } else {
          const selectedCountry = customFields || 'USA';
          this.store.dispatch(
            UpdateWithdrawCountry({ withdrawCountry: selectedCountry })
          );
        }
        this.isImplicitUSCanLocation =
          this.implicitUSCanada.includes(selectedCountry);
        this.getTransactionStatus();
        // this.populateData();
        this._populateCardSections();
        this.wallet = this.transactionResponse?.walletProvider;
      }
    });
    this.store.select(getRefundResponse).subscribe((response) => {
      if (!this.isEmpty(response)) {
        const errors = response?.errors;
        const mapiRefundError =
          errors &&
          errors.find((error: Error) => error.category?.includes('MAPI-'));
        const adaptRefunderError =
          errors &&
          errors.find((error: Error) => {
            return error.category?.includes('SAS-');
          });
        const ipRefundError =
          errors &&
          errors.find((error: Error) => {
            return error.category?.includes('IP-');
          });
        if (
          ipRefundError &&
          ipRefundError?.category === 'IP-20000' &&
          ipRefundError?.code === '4035'
        ) {
          this._errorEvent(
            adaptRefunderError,
            '',
            'getRefundError',
            'trnRefundDetails'
          );
          this.openSnackBar(
            this.labels?.stellar?.error?.unexpectedErrorContactMoneygram,
            this.labels?.stellar?.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        } else if (mapiRefundError) {
          this._errorEvent(
            mapiRefundError,
            '',
            'getRefundError',
            'trnRefundDetails'
          );
          this.openSnackBar(
            mapiRefundError?.message,
            this.labels?.stellar?.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        } else if (adaptRefunderError) {
          this._errorEvent(
            adaptRefunderError,
            '',
            'getRefundError',
            'trnRefundDetails'
          );
          this.openSnackBar(
            this.labels?.stellar?.error?.unableToProcess,
            this.labels?.stellar?.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        } else if (errors) {
          const uiMessage = this.labels?.stellar?.error?.processingError;
          this._errorEvent(
            undefined,
            uiMessage,
            'getRefundError',
            'trnRefundDetails'
          );
          this.openSnackBar(
            this.labels?.stellar?.error?.processingError,
            this.labels.stellar.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        }
      }
    });

    this.actions$
      .pipe(
        ofType(
          TransactionActions.transactionStatusFailed,
          TransactionActions.getRefundFailed
        )
      )
      .subscribe((error) => {
        const uiMessage = this.labels?.stellar?.error?.processingError;
        if (error) {
          this._errorEvent(
            error,
            uiMessage,
            'transactionStatusError',
            'trnStatusDetails'
          );
        }
        this.openSnackBar(uiMessage, this.labels.stellar.dismiss, {
          duration: 10000,
          panelClass: ['bg'],
        });
      });
  }

  getWithdrawOrPayAmount() {
    let value = this.transactionResponse?.sendAmountDetails?.totalAmount?.value;
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (this.kind === 'withdraw' && !fxRate) {
      return Number(value).toFixed(2);
    } else if (this.kind === 'withdraw') {
      return Number(value * fxRate).toFixed(2);
    } else {
      return Number(value);
    }
  }

  getExchangeAmountCurrency() {
    if (
      this.kind === 'withdraw' &&
      !!this.transactionResponse?.payoutAmountDetails?.fxRate
    ) {
      return this?.transactionResponse?.payoutAmountDetails?.totalAmount
        ?.currencyCode;
    }
    return this.transactionResponse?.sendAmountDetails?.totalAmount
      ?.currencyCode!;

    // return this.kind === 'withdraw' ?
    //   this.transactionResponse?.payoutAmountDetails?.totalAmount?.currencyCode! :
    //   this.transactionResponse?.sendAmountDetails?.totalAmount?.currencyCode!
  }

  displayFxRate() {
    return this.getExchangeAmountCurrency() === 'USD'
      ? `1 USDC = 1 USD`
      : `1 USDC = 1 USD = ${
          this.exchangeRate
        } ${this.getExchangeAmountCurrency()}`;
  }

  public _populateCardSections(): void {
    // if(this.kind === "deposit") {
    //   this.checkForSelectedLocation();
    // }
    this.sections = [
      {
        title: {
          name: this.sdfCardLabels.reviewPage.paymentInformation,
          value: this.exchangeRate ? this.displayFxRate() : '',
          isBold: true,
        },
        items: [
          {
            name: this.getAmountLabel(),
            value: this.getWithdrawOrPayAmount(),
            sendCurrency: this.getExchangeAmountCurrency(),
            isBold: false,
          },
          {
            name: this.sdfCardLabels.landingPage.payment.payMethod,
            value: this.getPaymentMethod(),
            isBold: false,
          },
          {
            name: this.sdfCardLabels.landingPage.payment.receiveMethod,
            value: this.getReceiveMethod(),
            isBold: false,
          },
          {
            name: this.sdfCardLabels.common.fees,
            value: this.getPartnerFees() || '0.00',
            sendCurrency: this.kind === 'deposit' ? this.transactionResponse?.sendAmountDetails?.totalAmount?.currencyCode! : this.transactionResponse?.payoutAmountDetails?.totalAmount?.currencyCode!,
            isBold: false,
            displayMinus: this.kind === 'withdraw' && Number(this.getPartnerFees()) > 0,
          },
          {
            name: this.sdfCardLabels.common.taxes,
            value: this.getTaxes(),
            sendCurrency:
              this.kind === 'withdraw'
                ? this.getTaxesCurrency()
                : this.transactionResponse?.sendAmountDetails?.taxes
                    ?.currencyCode!,
            isBold: false,
            displayMinus:
              this.kind === 'withdraw' && Number(this.getTaxes()) > 0,
          },
        ],
        footer: {
          name: this.getFooterName(),
          value:
            this.kind === 'withdraw'
              ? this.getTotalAmountWithdraw()
              : this.totalAmount,
          sendCurrency:
            this.kind === 'withdraw'
              ? this.getTotalAmountWithdrawCurrency()
              : this.totalAmountCurrency,
          isBold: true,
        },
      },
      {
        // title: this.labels?.stellar?.location?.depositLocation,
        title: {
          name: this.sdfCardLabels.reviewPage.paymentLocation,
          isDepositOnlyItem: true,
        },
        items: [
          {
            name: this.selectedLocation?.locationDetails?.name,
            value: this.getAddressInfo(true),
            isBold: true,
          },
        ],
      },
    ];

    if (this.kind === 'withdraw') {
      // this.sections = this.sections.filter(section => !section.title.isDepositOnlyItem);
      this.sections = this.sections.filter(
        (section: any) => !section?.title.isDepositOnlyItem
      );
    }

    if (!this.showPayInstructions) {
      this.sections.forEach((section) => {
        if (section) {
          delete section?.title;
        }
      });

      this.sections[0].items.unshift({
        name: this.sdfCardLabels.confirmationPage.receiver,
        value: this.getUserName(),
        isBold: false,
      });
    }
  }

  getPartnerFees(){
    const valFlow = (this.kind === 'deposit' ) ? 
                      this.transactionResponse?.payoutAmountDetails?.partnerFees?.value :
                      this.transactionResponse?.sendAmountDetails?.partnerFees?.value;
    const fxRateFlow = (this.kind === 'deposit' ) ? 
                      this.transactionResponse?.sendAmountDetails?.fxRate :
                      this.transactionResponse?.payoutAmountDetails?.fxRate;
    const value = Number(valFlow);
    const fxRate = Number(fxRateFlow);
    return (!isNaN(value) && !isNaN(fxRate))? (value * fxRate).toFixed(2) : "0.00";
  }
  
  getAddressInfo(isLocationDetails: boolean): any {
    let add1 = '';
    let add2 = '';
    if (isLocationDetails) {
      add1 = this.locationFinderService.getFormattedAddress({
        addressLine1: this.selectedLocation?.locationDetails?.addressLine1,
        addressLine2: this.selectedLocation?.locationDetails?.addressLine2,
        addressLine3: this.selectedLocation?.locationDetails?.addressLine3,
      });

      add2 = this.locationFinderService.getFormattedAddress({
        city: this.selectedLocation?.locationDetails?.city,
        state: this.selectedLocation?.locationDetails?.state,
        postalCode: this.selectedLocation?.locationDetails?.postalCode,
        zipCode: this.selectedLocation?.locationDetails?.zipCode,
      });
    }

    return `${add1}${add2}`;
  }

  isreadyToDisplay() {
    return !isEmpty(this.labels) && !isNil(this.transactionResponse);
  }

  getTotalAmount() {
    let amount: string | number;
    amount =
      this.kind === 'withdraw'
        ? this.transactionResponse?.payoutAmountDetails?.totalAmount?.value!
        : this.transactionResponse?.sendAmountDetails?.totalAmount?.value!;
    if (typeof amount === 'number') {
      amount = amount.toFixed(2);
    } else {
      amount = parseFloat(amount).toFixed(2);
    }
    this.totalAmount = parseFloat(amount).toFixed(2);

    let amountAddorSubFromWallet: string | number;

    amountAddorSubFromWallet =
      this.kind === 'deposit'
        ? this.transactionResponse?.payoutAmountDetails?.totalAmount?.value!
        : this.transactionResponse?.sendAmountDetails?.totalAmount?.value!;
    if (typeof amountAddorSubFromWallet === 'number') {
      amountAddorSubFromWallet = amountAddorSubFromWallet.toFixed(2);
    } else {
      amountAddorSubFromWallet = parseFloat(amountAddorSubFromWallet).toFixed(
        2
      );
    }
    this.totalAmountAddorSubFromWallet = parseFloat(
      amountAddorSubFromWallet
    ).toFixed(2);

    if (this.kind === 'deposit') {
      this.depositAmountString = replace(
        '%s',
        this.totalAmountAddorSubFromWallet,
        this.sdfCardLabels.confirmationPage.amountAdding
      );
    } else {
      this.withdrawAmountString = replace(
        '%s',
        this.totalAmountAddorSubFromWallet,
        this.sdfCardLabels.confirmationPage.amountWithdraw
      );
    }
    this.getTotalExchangeAmountCurrency();
  }

  copyCode() {
    let copyContent: any = '';
    if (this.kind === 'deposit' && !this.isformFreeLocation) {
      copyContent = this.transactionResponse?.confirmationNumber || '';
    } else {
      copyContent = this.confirmRefundRefNum || '';
    }
    this.clipboard.copy(copyContent);
  }

  getConfirmationCode() {
    if (this.kind === 'withdraw') {
      const refText =
        this.labels.stellar.confirmation.referenceNumber.split(' ');
      const refWords = refText
        .map((text: any) => text[0] + text.slice(1).toLowerCase())
        .join(' ');
      return `${refWords} ${this.refNumber}`;
    }
    return `${this.sdfCardLabels.confirmationPage.accountNumber} ${this.transactionResponse?.confirmationNumber}`;
  }

  getTotalExchangeAmountCurrency() {
    this.totalAmountCurrency =
      this.kind === 'withdraw'
        ? this.transactionResponse?.payoutAmountDetails?.totalAmount
            ?.currencyCode!
        : this.transactionResponse?.sendAmountDetails?.totalAmount
            ?.currencyCode!;
  }

  getSelectedIdInfo(id: string | any) {
    // return pathOr(id, ['stellar', 'enumsObj', 'PERSONAL_ID1_TYPE', id], this.labels);
    return 'Photo ID'; // ToDo once API provides this info, then UI can display ID info
  }

  getPrimaryIdString() {
    const id = this.primaryIdDetails
      ? this.sdfCardLabels.confirmationPage.nextSteps.idType[this.primaryIdDetails as keyof typeof this.sdfCardLabels.confirmationPage.nextSteps.idType] // Todo: #refactor - there may be a better way to implement this
      : '';
    return replace(
      '%s',
      id,
      this.sdfCardLabels.confirmationPage.nextSteps.paraTwo
    );
  }

  splitExplicitPurpose(purpose: string) {
    return purpose?.split(',');
  }

  mapLocationServices(servicesObj: LocationResultServices) {
    let services = [];
    for (const [key, value] of Object.entries(servicesObj)) {
      // Iterate through key value pairs and
      // filter only true i.e specific servie is available
      if (value === true) {
        // search specific key in labels and allow only if label is available
        if (this.locationLabels[key]) {
          services.push(this.locationLabels[key]);
        }
      }
    }
    return services;
  }

  // We are using as a quick fix to remove global asterik rull inside the style.css file. Once this component is redesigned, we will not need to use this quick fix
  removeGlobalAsteriskCSSRule(): void {
    const styleSheets = document.styleSheets;
    for (let i = 0; i < styleSheets.length; i++) {
      const styleSheet = styleSheets[i] as CSSStyleSheet;
      let cssRules: CSSRuleList;
      try {
        cssRules = styleSheet.cssRules || styleSheet.rules;
      } catch (error) {
        continue;
      }

      if (cssRules) {
        for (let j = 0; j < cssRules.length; j++) {
          const rule = cssRules[j];
          // console.log('WHat is rule', rule instanceof CSSStyleRule && rule.selectorText ? rule.selectorText : rule)
          if (
            rule instanceof CSSStyleRule &&
            rule.selectorText === '*' &&
            rule.style.margin === '0px' &&
            rule.style.padding === '0px' &&
            rule.style.boxSizing === 'border-box'
          ) {
            styleSheet.deleteRule(j);
            return;
          }
        }
      }
    }
  }

  openRefundDialog() {
    const transactionData: RefundModalData = {
      transactionId: this.transactionId,
      refNumber: this.transactionResponse?.referenceNumber,
      queryRefNumber: this.refNumber,
      amountDetails: this.transactionResponse.payoutAmountDetails.totalAmount,
      flowType: this.kind,
    };
    this.dialogService.open(TransactionStatusgModalComponent, {
      data: {
        transactionData,
        cmsTranLabels: this.transactionLabels,
        cmsLabels: this.labels,
        locale: this.locale,
        endpoint: this.endpointVersion,
      },
      ariaLabel: 'title',
      role: 'alertdialog',
    });
  }

  openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    this._snackBar.open(message, action, config);
  }

  getTransactionStatus() {
    if (this.kind === 'deposit') {
      this.trnStatus = this.sdfCardLabels.confirmationPage.cashInStatusHeader;
      // this.withdrawnOrDepositAmountString = this.sdfCardLabels.confirmationPage.amountAdding;
      this.withdrawnOrDepositAmountString = this.depositAmountString;
      this.amountPaidOrPayAtStore =
        this.sdfCardLabels.confirmationPage.payAtStore;
    } else {
      this.trnStatus = this.sdfCardLabels.confirmationPage.cashOutStatusHeader;
      this.withdrawnOrDepositAmountString = this.withdrawAmountString;
      this.amountPaidOrPayAtStore =
        this.sdfCardLabels.confirmationPage.pickAmount;
    }
    switch (this.transactionResponse?.transactionStatus?.toLowerCase()) {
      case 'pending_user_transfer_start':
        if (this.kind === 'withdraw') {
          this.trnStatus = this.transactionLabels?.status?.waitingForPayment;
        }
        this.showPayInstructions = true;
        this.transactionStatusIconSrc =
          'assets\\images\\trn-status-waiting-icon.svg';
        break;
      case 'pending_user_transfer_complete':
        // this.trnStatus = this.transactionLabels?.status?.transactionReadyForPickup;
        this.showPayInstructions = true;
        break;
      case 'completed':
        this.trnStatus = this.transactionLabels?.status?.transactionComplete;
        this.transactionStatusIconSrc =
          'assets\\images\\trn-status-green-check.svg';
        this.amountPaidOrPayAtStore = this.getAmountPaidOrPayAtStoreLabel();
        this.withdrawnOrDepositAmountString = this.getWithdrawnOrDepositAmountString();
        break;
      case 'pending_anchor':
        if (this.transactionSubstatus.length > 0 && !!this.transactionSubstatus[0] && (this.transactionSubstatus[0] === 'HOLD - INTERVIEW NEEDED' || this.transactionSubstatus[0] === 'HOLD - INTERNAL REVIEW')) {
          this.trnStatus = this.transactionLabels?.status?.onHoldContactMoneygram;
          this.transactionStatusIconSrc = 
            'assets\\images\\red-exclamation-icon.svg'; 
          this.helpText = this.sdfCardLabels?.confirmationPage?.nextSteps?.onHold?.para1;
          this.helpTextLine2 = this.sdfCardLabels?.confirmationPage?.nextSteps?.onHold?.para2;
        }
        else if (this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
          // Add specific handling for BANK_DEPOSIT payout option
          this.trnStatus = 'Your money is on the way';
          this.transactionStatusIconSrc =
            'assets\\images\\trn-status-green-check.svg';
          this.amountPaidOrPayAtStore = this.labels.stellar.estimateConfirmation.depositAmount;
          this.withdrawnOrDepositAmountString = 'Money available in 0-1 business days';
        }
        else {
          this.trnStatus = this.transactionLabels?.status?.transactionProcessing;
          this.transactionStatusIconSrc =
            'assets\\images\\trn-status-processing-icon.svg';
          this.amountPaidOrPayAtStore = this.sdfCardLabels.common.refundAmount;
          this.withdrawnOrDepositAmountString = '';
        }
        break;
      case 'refunded':
        this.trnStatus = this.transactionLabels?.status?.transactionRefunded;
        this.transactionStatusIconSrc =
          'assets\\images\\trn-status-green-check.svg';
        this.amountPaidOrPayAtStore = this.sdfCardLabels.common.refundAmount;
        this.withdrawnOrDepositAmountString = '';
        break;
      case 'expired':
        this.helpText = this.helpText =
          this.transactionLabels?.status?.expiredHelpText;
        this.trnStatus = this.transactionLabels?.status?.expired;
        break;
      case 'incomplete':
        this.helpText = this.transactionLabels?.status?.incompleteHelpText;
        this.trnStatus = this.transactionLabels?.status?.incomplete;
        break;
      case 'refund_only':
        this.trnStatus = this.transactionLabels?.status?.refundOnly;
        break;
      case 'error':
        this.trnStatus = this.transactionLabels?.status?.transactionRejected;
        break;
      default:
        this.trnStatus = this.transactionResponse?.transactionStatus;
    }
  }

  getTransactionKind() {
    if (this.kind === 'withdraw') {
      return this.labels?.stellar?.withdraw || this.kind;
    }
    return this.labels?.stellar?.deposit || this.kind;
  }

  getTransactionLabel() {
    if (this.kind === 'withdraw') {
      //return this.transactionLabels?.receiver;
      // return "Personal Information"
      return this.transactionLabels?.personalInformation;
    } else if (this.kind === 'deposit') {
      return this.transactionLabels?.sender;
    } else {
      return '';
    }
  }

  getHelpText() {}
  closeWindow() {
    setTimeout(() => {
      window.close();
    }, 400);
  }

  getCountryLabel() {
    if (this.kind === 'withdraw') {
      return this.transactionLabels?.cashOutCountry;
    }
    return this.labels?.stellar?.estimate?.cashInCountry;
  }

  getStateLabel() {
    if (this.kind === 'withdraw') {
      return this.transactionLabels?.cashOutState;
    }
    return this.labels?.stellar?.estimate?.cashInState;
  }

  getFormattedWalletName() {
    if (this.transactionResponse?.walletProvider?.toLowerCase() === 'vibrant') {
      return 'Vibrant';
    } else if (
      this.transactionResponse?.walletProvider?.toLowerCase() === 'cinko'
    ) {
      return 'CiNKO';
    }
    return this.transactionResponse?.walletProvider;
  }

  getFooterName() {
    if (this.kind === 'deposit') {
      return this.sdfCardLabels?.common?.totalPayAmount;
    } else if (this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
      return this.labels.stellar.estimateConfirmation.depositAmount;
    } else {
      return this.sdfCardLabels?.common?.totalPickupAmount;
    }
  }

  getAmountLabel() {
    if (this.kind === 'deposit') {
      return this.sdfCardLabels.common.yourPayAmount;
    } else if (this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
      return this.labels.stellar.summary.withdrawalAmount;
    } else {
      return this.sdfCardLabels.common.yourWithdrawAmount;
    }
  }

  getAmountPaidOrPayAtStoreLabel() {
    if (this.kind === 'deposit') {
      return this.sdfCardLabels.common.youPaid;
    } else if (this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
      return this.labels.stellar.estimateConfirmation.depositAmount;
    } else {
      return this.sdfCardLabels.confirmationPage.pickAmount;
    }
  }

  getWithdrawnOrDepositAmountString() {
    const amount = `${this.getAmount()} ${this.transactionResponse
      ?.sendAmountDetails?.amount?.currencyCode!}`;
    if (this.kind === 'deposit') {
      return `${amount} ${this.sdfCardLabels.common.addedTowallet}`;
    } else if (this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
      return '';
    } else {
      return `${amount} ${this.sdfCardLabels.common.withdrawnFromwallet}`;
    }
  }

  getPaymentMethod() {
    if (this.kind === 'withdraw') {
      return this.transactionResponse &&
        this.transactionResponse?.walletProvider
        ? `${this.getFormattedWalletName()} ${
            this.labels.stellar.summary.wallet
          }`
        : this.labels.stellar.summary.wallet;
    }
    return this.transactionLabels?.cash;
  }

  getReceiveMethod() {
    if (this.kind === 'withdraw' && this.transactionResponse?.payoutOptionsCode === 'BANK_DEPOSIT') {
      return this.labels.stellar.signIn.paymentMethods.bankAccount ;
    }
    else if (this.kind === 'withdraw') {
      return this.labels?.stellar?.summary?.cashPickup;
    }
    return this.transactionResponse && this.transactionResponse?.walletProvider
      ? `${this.getFormattedWalletName()} ${
          this.labels?.stellar?.summary?.wallet
        }`
      : this.labels?.stellar?.summary?.wallet;
  }

  getUserName() {
    return `${this.transactionResponse?.receiverFirstName} ${this.transactionResponse?.receiverMiddleName} ${this.transactionResponse?.receiverLastName} ${this.transactionResponse?.receiverSecondLastName}`;
  }

  getStateName() {
    const country = getCountryConfig(this.transactionResponse?.SenderCountry);

    if (country && country.states) {
      const state = country.states.find((state) => {
        return this.transactionResponse?.SenderState === state.code;
      });
      return state ? state?.name : '';
    }
    return '';
  }

  createSenderReceiverSection() {
    // If neither name nor country exists, no receiver/sender section will be added to section
    if (
      !this.transactionResponse?.receiverFirstName &&
      !this.transactionResponse?.SenderCountry
    ) {
      return;
    }

    const section = {
      title: this.getTransactionLabel(),
      items: <SenderReceiverSection[]>[],
    };

    // Add sender/receiver name, if provided in transactionResponse
    if (this.transactionResponse?.receiverFirstName) {
      const nameSection = {
        name: this.transactionLabels?.legalName,
        value: this.getUserName(),
        isBold: false,
      };

      section.items.push(nameSection);
    }

    // Add send/receive country, if provided in transactionResponse
    if (this.transactionResponse?.SenderCountry) {
      // TODO: country name only displays in English, CMS translations not yet implemented
      const countrySection = {
        name: this.getCountryLabel(),
        value: getCountryConfig(this.transactionResponse?.SenderCountry).name,
        isBold: false,
      };

      section.items.push(countrySection);
    }

    // Add Receiver/Sender details section to front of this.sections
    return this.sections.unshift(section);
  }

  getFormattedAddress(loc: any): string {
    let retString = '';

    const propsToCheck = [
      'addressLine1',
      'addressLine2',
      'addressLine3',
      'city',
      'state',
      'postalCode',
      'zipCode',
    ];

    propsToCheck.forEach((prop: string) => {
      if (
        (loc.hasOwnProperty(prop) && !!loc[prop]) ||
        // for google location api, we get a postalCode back,
        // for TransactionDetails we get zip
        (prop === 'postalCode' && !!loc['zipCode'])
      ) {
        if (prop === 'postalCode') {
          retString += `${!!retString ? ' ' : ''}${
            loc[prop] || loc['zipCode']
          }`;
        } else if (prop !== 'zipCode') {
          retString += `
            ${!!retString ? ' ' : ''}${loc[prop]}${prop === 'state' ? ',' : ''}
          `;
        }
      }
    });

    if (!retString) {
      console.warn('Could not format anything in `getFormattedAddress`');
    }
    return retString;
  }

  populateData() {
    const isRefunded =
      this.transactionResponse?.transactionStatus?.toLowerCase() === 'refunded';
    this.sections = [
      {
        title: this.transactionLabels?.paymentInformation,
        items: [
          {
            name: this.transactionLabels?.kind,
            value: this.getTransactionKind(),
            isBold: false,
          },
          {
            name: this.transactionLabels?.paymentMethod,
            value: this.getPaymentMethod(),
            isBold: false,
          },
          {
            name: this.transactionLabels?.receiveMethod,
            value: this.getReceiveMethod(),
            isBold: false,
          },
          {
            name: this.transactionLabels?.transactionId,
            value: this.transactionId,
            isBold: false,
          },
        ],
      },
    ];
    const amount = {
      name: isRefunded
        ? this.transactionLabels?.receiveAmount
        : this.getReceiveAmountLabel(),
      value: this.getAmount(),
      sendCurrency:
        this.transactionResponse?.sendAmountDetails?.amount?.currencyCode!,
      isBold: false,
    };
    const fees = {
      name: this.transactionLabels?.fees,
      value: this.getFees(),
      sendCurrency:
        this.transactionResponse?.sendAmountDetails?.fees?.currencyCode!,
      isBold: false,
      displayMinus: this.kind === 'withdraw' && Number(this.getFees()) > 0,
    };
    const taxes = {
      name: this.transactionLabels?.taxes,
      value: this.getTaxes(),
      sendCurrency:
        this.transactionResponse?.sendAmountDetails?.taxes?.currencyCode!,
      isBold: false,
      displayMinus: this.kind === 'withdraw' && Number(this.getTaxes()) > 0,
    };

    // const partnerFees: itemSummarySection = { // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
    //   name: 'Partner Fees', // Todo: hardcoded label. Will be updated when language is finalized
    //   value: this.getPartnerFees(),
    //   sendCurrency: this.transactionResponse?.sendAmountDetails?.partnerFees?.currencyCode!,
    //   isBold: false,
    //   displayMinus: this.kind === 'withdraw' && Number(this.getPartnerFees()) > 0,
    // }

    // const partnerTaxes: itemSummarySection = { // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
    //   name: 'Partner Taxes', // Todo: hardcoded label. Will be updated when language is finalized
    //   value: this.getPartnerTaxes(),
    //   sendCurrency: this.transactionResponse?.sendAmountDetails?.partnerTaxes?.currencyCode!,
    //   isBold: false,
    //   displayMinus: this.kind === 'withdraw' && Number(this.getPartnerTaxes()) > 0,
    // }

    const sectionItems = [];
    if (this.kind === 'deposit') {
      sectionItems.push(amount);
      sectionItems.push(fees);
      sectionItems.push(taxes);
      // if (!isNaN(partnerFees.value) && partnerFees.value !== null && typeof partnerFees.value !== "undefined") { sectionItems.push(partnerFees); } // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
      // if (!isNaN(partnerTaxes.value) && partnerTaxes.value !== null && typeof partnerTaxes.value !== 'undefined') { sectionItems.push(partnerTaxes); } // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
    } else {
      sectionItems.push(fees);
      sectionItems.push(taxes);
      sectionItems.push(amount);
    }
    this.summarySections = [
      {
        title: isRefunded
          ? this.transactionLabels?.refundSummary
          : this.transactionLabels.costSummary,
        items: sectionItems,
      },
    ];

    this.createSenderReceiverSection();

    // If state info is available then only add to sections and display
    if (this.getStateName()) {
      const stateSection = {
        name: this.getStateLabel(),
        value: this.getStateName()!,
        isBold: false,
      };
      this.sections.filter((section) => {
        // State is only displayed for Cash-Out/Withdraw transactions
        if (section.title === this.transactionLabels.receiver) {
          return section.items.push(stateSection);
        }
        return section;
      });
    }

    // No need to display as per Yassir for now, so commented for now
    // if(this.transactionResponse?.sendAmountDetails?.discounts || (this.discounts != "" && this.kind === "deposit")) {
    //   const discountVal = this.transactionResponse?.sendAmountDetails?.discounts?.value ? this.transactionResponse?.sendAmountDetails?.discounts?.value : this.discounts;

    //   const discounts =  {
    //     name: this.transactionLabels?.discount,
    //     value: `-${discountVal}`,
    //     sendCurrency: this.transactionResponse?.sendAmountDetails?.discounts?.currencyCode!,
    //     isBold: false,
    //   }
    //   this.summarySections[0].items.push(discounts)
    // }

    /*if(this.kind === 'deposit' && this.transactionResponse?.sendAmountDetails?.totalAmount?.value) {
      const payoutLocation =  {
        //name: this.transactionLabels?.toPayAtLocation,
        name: "Amount to Pay",
        value: this.getpayOutCost(),
        sendCurrency: this.transactionResponse?.sendAmountDetails?.totalAmount?.currencyCode,
        isBold: true,
      }
      this.summarySections[0].items.push(payoutLocation)
    }*/
  }

  getpayOutCost() {
    let payoutAmount: string;
    const payoutValue =
      this.transactionResponse?.sendAmountDetails?.totalAmount?.value;
    if (typeof payoutValue === 'number') {
      payoutAmount = payoutValue.toFixed(2);
    } else {
      payoutAmount = parseFloat(payoutValue).toFixed(2);
    }
    return parseFloat(payoutAmount).toFixed(2);
  }

  getTotalUSDCCost() {
    let totalAmount: string;
    const totalAmountValue =
      this.kind !== 'deposit'
        ? this.transactionResponse?.sendAmountDetails?.totalAmount?.value
        : this.transactionResponse?.payoutAmountDetails?.totalAmount?.value;
    if (typeof totalAmountValue === 'number') {
      totalAmount = totalAmountValue.toFixed(2);
    } else {
      totalAmount = parseFloat(totalAmountValue).toFixed(2);
    }
    return parseFloat(totalAmount).toFixed(2);
  }

  getTotalCost() {
    let totalAmount: string;
    const totalAmountValue =
      this.kind === 'deposit'
        ? this.transactionResponse?.sendAmountDetails?.totalAmount?.value
        : this.transactionResponse?.payoutAmountDetails?.totalAmount?.value;
    if (typeof totalAmountValue === 'number') {
      totalAmount = totalAmountValue.toFixed(2);
    } else {
      totalAmount = parseFloat(totalAmountValue).toFixed(2);
    }
    return parseFloat(totalAmount).toFixed(2);
  }

  getTotalCostCurrency() {
    return this.kind === 'deposit'
      ? this.transactionResponse?.sendAmountDetails?.totalAmount?.currencyCode
      : this.transactionResponse?.payoutAmountDetails?.totalAmount
          ?.currencyCode;
  }

  getAmount() {
    let amount: string;
    if (
      typeof this.transactionResponse?.sendAmountDetails?.amount?.value ===
      'number'
    ) {
      amount =
        this.transactionResponse?.sendAmountDetails?.amount?.value.toFixed(2);
    } else {
      amount = parseFloat(
        this.transactionResponse?.sendAmountDetails?.amount?.value!
      ).toFixed(2);
    }

    return parseFloat(amount).toFixed(2);
  }

  getFees() {
    let value = this.transactionResponse?.sendAmountDetails?.fees?.value;
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (this.kind === 'withdraw' && !fxRate) {
      return Number(value).toFixed(2);
    } else if (this.kind === 'withdraw') {
      return Number(value * fxRate).toFixed(2);
    }
    return Number(value).toFixed(2);
  }

  getFeesCurrency() {
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (this.kind === 'withdraw' && !!fxRate) {
      return this.transactionResponse?.payoutAmountDetails?.totalAmount
        ?.currencyCode;
    }
    return this.transactionResponse?.sendAmountDetails?.fees?.currencyCode;
  }

  getTaxes() {
    let value = this.transactionResponse?.sendAmountDetails?.taxes?.value;
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (this.kind === 'withdraw' && !fxRate) {
      return Number(value).toFixed(2);
    } else if (this.kind === 'withdraw') {
      return Number(value * fxRate).toFixed(2);
    }
    return Number(value).toFixed(2);
  }

  getTaxesCurrency() {
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (this.kind === 'withdraw' && !!fxRate) {
      return this.transactionResponse?.payoutAmountDetails?.totalAmount
        ?.currencyCode;
    }
    return this.transactionResponse?.sendAmountDetails?.taxes?.currencyCode;
  }

  getTotalAmountWithdraw() {
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    const value = !!fxRate
      ? this.transactionResponse?.payoutAmountDetails?.totalAmount?.value
      : this.transactionResponse?.sendAmountDetails?.amount?.value;
    return Number(value).toFixed(2);
  }

  getTotalAmountWithdrawCurrency() {
    const fxRate = this.transactionResponse?.payoutAmountDetails?.fxRate || '';
    if (!!fxRate) {
      return this.transactionResponse?.payoutAmountDetails?.totalAmount
        ?.currencyCode;
    }
    return this.transactionResponse?.sendAmountDetails?.amount?.currencyCode;
  }

  // getTaxes() {
  //   let taxes: string;
  //   if (typeof this.transactionResponse?.sendAmountDetails?.taxes?.value === 'number') {
  //     taxes = this.transactionResponse?.sendAmountDetails?.taxes?.value?.toFixed(2)
  //   } else {
  //     taxes = parseFloat(this.transactionResponse?.sendAmountDetails?.taxes?.value!).toFixed(2)
  //   }

  //   return parseFloat(taxes).toFixed(2);
  // }

  // getPartnerFees() { // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
  //   let partnerFees: string;
  //   if (typeof this.transactionResponse?.sendAmountDetails?.partnerFees?.value === 'number') {
  //     partnerFees = this.transactionResponse?.sendAmountDetails?.partnerFees?.value?.toFixed(2)
  //   } else {
  //     partnerFees = parseFloat(this.transactionResponse?.sendAmountDetails?.partnerFees?.value!).toFixed(2)
  //   }

  //   return parseFloat(partnerFees).toFixed(2)
  // }

  // getPartnerTaxes() { // TODO: not targeted for June 18th, also requirements changed for PartnerFees, so commenting out for now
  //   let partnerTaxes: string;
  //   if (typeof this.transactionResponse?.sendAmountDetails?.partnerTaxes?.value === 'number') {
  //     partnerTaxes = this.transactionResponse?.sendAmountDetails?.partnerTaxes?.value?.toFixed(2)
  //   } else {
  //     partnerTaxes = parseFloat(this.transactionResponse?.sendAmountDetails?.partnerTaxes?.value!).toFixed(2)
  //   }

  //   return parseFloat(partnerTaxes).toFixed(2);
  // }

  getTotalCostLabel() {
    if (
      this.transactionResponse?.transactionStatus?.toLowerCase() === 'refunded'
    ) {
      return this.transactionLabels?.refundAmount;
    }
    if (this.kind === 'withdraw') {
      return this.transactionLabels?.withdrawalFromWallet;
    }
    return this.transactionLabels?.depositToWallet;
  }

  getReceiveAmountLabel() {
    // return this.labels?.stellar?.summary?.cashInAmount
    return this.transactionLabels?.exchangeAmount;
  }

  cancelTransfer() {
    this._analyticsBtnClickEvent('getTransactionRefund');
    this.openRefundDialog();
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  printPage() {
    window.print();
  }

  public decodeJWT(token: string): string {
    const arrayToken = token.split('.');
    const decodedToken = JSON.parse(atob(arrayToken[1]));
    return decodedToken;
  }

  public isClientNameInJWT(token: string): boolean {
    const decodedToken: any = this.decodeJWT(token); // Todo: Tim: Fix type
    return !!decodedToken['client_name'];
  }

  private _paramsDataEvent() {
    const paramsObj: any = {}; // Todo: Tim: Fix type
    paramsObj['event'] = 'loadedStatusPage';
    paramsObj['language'] = this.locale?.substring(0, 2);
    paramsObj['country'] = this.locale?.substring(3, 5);
    paramsObj['transaction-id'] = this.transactionId;
    paramsObj['wallet-provider'] = this.wallet;
    paramsObj['operation'] = this.kind;
    paramsObj['reference-number'] = this.refNumber;
    paramsObj['page-title'] = PageTitles.TRANSACTION_STATUS_PAGE;
    this.dataLayer.push(paramsObj);
  }

  private _analyticsBtnClickEvent(event: string) {
    const clickInfoObj: any = {}; // Todo: Tim: Fix type
    clickInfoObj['event'] = event;
    clickInfoObj['transaction-Id'] = this.transactionId;
    clickInfoObj['operation'] = this.kind;
    clickInfoObj['page-title'] = PageTitles.TRANSACTION_STATUS_PAGE;
    this.dataLayer.push(clickInfoObj);
  }

  private _errorEvent(
    error: Error | undefined,
    message: string,
    event: string,
    pageName: string
  ) {
    const errorObj: any = {}; // Todo: Tim: Fix type
    errorObj['event'] = event;
    errorObj['event-page-name'] = pageName;
    errorObj['transaction-Id'] = this.transactionId;
    errorObj['operation'] = this.kind;
    if (error) {
      errorObj['error-category'] = error?.category;
      errorObj['error-code'] = error?.code;
      errorObj['backend-error-msg'] = error?.message;
    } else {
      errorObj['ready-for-commit'] = false;
    }
    errorObj['ui-custom-error-msg'] = message;
    this.dataLayer.push(errorObj);
  }

  getFirstBulletPoint(): string {
    if (
      this.wallet?.toLowerCase() === 'vibrant' ||
      this.wallet?.toLowerCase() === 'wyre' ||
      this.wallet?.toLowerCase() === 'meru' ||
      this.wallet?.toLowerCase() === 'cinko'
    ) {
      return this.labels.stellar.statusUpdates.withdraw.firstBulletVibrant;
    } else {
      return this.labels.stellar.statusUpdates.withdraw.firstBulletLobstr;
    }
  }

  shouldShowFirstBulletPoint(): boolean {
    return this.kind === 'withdraw' && 
           (['lobstr', 'decaf', 'beans'].includes(this.wallet?.toLowerCase()) && 
            this.transactionStatus === 'pending_user_transfer_start');
  }
}
